import { FieldsStorylineLinkRelatedType, FieldstorylineNoteRelatedType, annotationType } from '@/types/cms/Storylines'

type TagName =
  | 'bold'
  | 'strong'
  | 'italic'
  | 'underline'
  | 'strike'
  | 'subscript'
  | 'superscript'
  | 'inline_link'
  | 'note'
  | 'internal_link'

interface StartAnnotationProps {
  pos?: number
  name: TagName
  value?: string
  target?: string
  noFollow?: boolean
  title?: string
}

interface EndAnnotationProps {
  pos?: number
  name: TagName
}

const getTag = (tagName: TagName) => {
  switch (tagName) {
    case 'bold':
      return 'b'
    case 'inline_link':
      return 'a'
    case 'internal_link':
      return 'a'
    case 'italic':
      return 'i'
    case 'note':
      return 'mark'
    case 'strong':
      return 'b'
    case 'subscript':
      return 'sub'
    case 'superscript':
      return 'sup'
    case 'underline':
      return 'u'

    default:
      return tagName
  }
}

const annotationConvert = (fields: annotationType) => {
  const escapeChar = (char: string) => {
    switch (char) {
      case '&':
        return '&amp;'
      case '<':
        return '&lt;'
      case '>':
        return '&gt;'
      case '"':
        return '&quot;'
      case "'":
        return '&#39;'
      default:
        return char
    }
  }

  if (fields.annotations && fields.annotations.length === 0) {
    return fields.value.split('').map(escapeChar).join('')
  }

  let annotated = ''

  const startAnnotations: Array<StartAnnotationProps> = []
  let endAnnotations: Array<EndAnnotationProps> = []

  fields.annotations.forEach((a) => {
    if (a.name === 'inline_link' || a.name === 'internal_link') {
      startAnnotations.push({
        pos: a.index,
        name: a.name,
        value:
          a.name === 'inline_link'
            ? (a.value as FieldsStorylineLinkRelatedType).uri?.value
            : (a.value as FieldsStorylineLinkRelatedType).relation?.value,
        target: (a.value as FieldsStorylineLinkRelatedType).newWindow?.value ? '_blank' : '_self',
        noFollow: (a.value as FieldsStorylineLinkRelatedType).noFollow?.value !== 'false',
      })
    } else if (a.name === 'note') {
      startAnnotations.push({
        pos: a.index,
        name: a.name,
        title: (a?.value as FieldstorylineNoteRelatedType)?.text?.value,
      })
    } else {
      startAnnotations.push({ pos: a.index, name: a.name })
    }
    endAnnotations.push({ pos: a.index + a.length, name: a.name })
  })
  endAnnotations = endAnnotations.reverse()

  for (let i = 0; i <= fields.value.length; i++) {
    endAnnotations
      .filter((a) => a.pos === i)
      .forEach((annotation) => {
        annotated = annotated + `</${getTag(annotation.name)}>`
      })
    startAnnotations
      .filter((a) => a.pos === i)
      .forEach((annotation) => {
        if (annotation.name === 'inline_link' || annotation.name === 'internal_link') {
          annotated =
            annotated +
            `<${getTag(annotation.name)} class=${annotation.name} ${
              annotation.noFollow ? 'rel=nofollow' : ''
            } href=${annotation.value} target=${annotation.target}>`
        } else {
          annotated =
            annotated +
            `<${getTag(annotation.name)} class=${annotation.name} ${
              annotation.title ? `title="${annotation.title}"` : ''
            }>`
        }
      })
    if (i < fields.value.length) {
      annotated = annotated + escapeChar(fields.value.charAt(i))
    }
  }
  return annotated
}

export default annotationConvert
